export const roleTypes = [
  { key: 1, title: "超级管理员" },
  { key: 2, title: "管理员" },
  { key: 3, title: "阵地管理员" },
];

export const getRoleTypeText = function(role) {
  let res = roleTypes.find((r) => r.key == role);
  return res ? res.title : null;
};

export const deptItems = [
  {
    key: "name",
    label: "部门名称",
    component: "a-input",
    props: {
      placeholder: "请输入部门名称",
    },
    rules: [{ required: true, message: "请输入部门名称", trigger: "blur" }],
  },
  {
    key: "order",
    label: "排序",
    component: "a-input-number",
    props: {
      placeholder: "数字越小排位越前",
    },
    style: {
      width: "100%",
    },
  },
];

export const adminItems = [
  {
    key: "name",
    label: "姓名",
    component: "a-input",
    props: {
      placeholder: "请输入成员姓名",
    },
    rules: [{ required: true, message: "请输入成员姓名", trigger: "blur" }],
  },
  {
    key: "tel",
    label: "手机号码",
    component: "a-input",
    props: {
      placeholder: "请输入成员手机号码",
    },
    rules: [{ required: true, message: "请输入成员手机号码", trigger: "blur" }],
  },
  {
    key: "password",
    label: "登录密码",
    component: "a-input",
    props: {
      placeholder: "用于后台管理系统登录的密码",
    },
    rules: [{ required: true, message: "请输入成员登录密码", trigger: "blur" }],
  },
  {
    key: "dept",
    label: "部门",
    component: "a-select",
    props: {
      options: [],
      placeholder: "请选择部门",
    },
    style: {
      width: "100%",
    },
    rules: [{ required: true, message: "请选择部门", trigger: "change" }],
  },
  {
    key: "role",
    label: "角色",
    component: "a-select",
    props: {
      // options: roleTypes,
      options: [],
      placeholder: "请选择角色",
    },
    style: {
      width: "100%",
    },
    rules: [{ required: true, message: "请选择角色", trigger: "change" }],
  },
];

export const passwordItems = [
  {
    key: "password",
    label: "新密码",
    component: "a-input",
    props: {
      placeholder: "请输入新密码",
      type: "password",
    },
    rules: [{ required: true, message: "请输入新密码", trigger: "blur" }],
  },
  {
    key: "second",
    label: "再次输入新密码",
    component: "a-input",
    props: {
      placeholder: "请再次输入新密码",
      type: "password",
    },
    rules: [{ required: true, message: "请再次输入新密码", trigger: "blur" }],
  },
];

// const list = [
//   {
//     id: 1,
//     name: "杭统云E家",
//     dept_list: [
//       {
//         id: 1,
//         name: "部领导",
//         dept_list: [...],
//         admin_list: [],
//       },
//       {
//         id: 2,
//         name: "办公室",
//         dept_list: [...],
//         admin_list: [],
//       },
//     ],
//     admin_list: [
//       { id: 1, name: "张三" },
//       { id: 2, name: "李四" },
//     ],
//   },
//   {
//     id: 2,
//     name: "浙江同心之家",
//     dept_list: [...],
//     admin_list: [...],
//   }
// ];
